export default __webpack_public_path__ + "static/media/rabbit-yellow.d3383ee9.png";